/* eslint-disable @next/next/no-img-element */

import {image} from '../Markdown.css';
import {ImageProps} from '../Markdown.types';

export const Image = ({alt, src}: ImageProps) => {
  return <img src={src} alt={alt} className={image} />;
};
